import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ServiceHero from './components/ServiceHero';
import PricingPlans from './components/PricingPlans';
import ServiceDetails from './components/ServiceDetails';
import FAQ from './components/FAQ';
import ContactCTA from './components/ContactCTA';
import SEOHead from '../../components/SEOHead';

export default function ServicesPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How long does the setup process take?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The timeline varies by package. Silver package training can be completed in 1-2 weeks. Gold package typically takes 4-8 weeks depending on renovation scope. Platinum package averages 8-12 weeks for complete turnkey service."
        }
      },
      {
        "@type": "Question",
        "name": "Do you help with permits and regulations?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Our Gold and Platinum packages include comprehensive permit assistance. We help you navigate local regulations, zoning requirements, and ensure your property meets all legal requirements for short-term rentals."
        }
      },
      {
        "@type": "Question",
        "name": "What areas do you serve?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We're based in Newark, Delaware and primarily serve properties throughout Delaware and surrounding Mid-Atlantic states. Contact us to discuss your specific location."
        }
      },
      {
        "@type": "Question",
        "name": "Can I upgrade my package later?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely! Many clients start with our Silver package and upgrade as they see the value. We'll credit your initial investment toward the upgraded package."
        }
      },
      {
        "@type": "Question",
        "name": "What kind of ROI can I expect?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "While results vary by location and property type, our clients typically see 15-30% annual returns on their investment. Many recover their setup costs within the first 6-12 months of operation."
        }
      }
    ]
  };

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Airbnb Property Setup and Management",
    "provider": {
      "@type": "ProfessionalService",
      "name": "Aire University",
      "telephone": "+1-302-500-3373",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "2043 Pulaski Hwy",
        "addressLocality": "Newark",
        "addressRegion": "DE",
        "postalCode": "19702",
        "addressCountry": "US"
      }
    },
    "areaServed": {
      "@type": "State",
      "name": "Delaware"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Airbnb Setup Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Silver Package - DIY Host Training",
            "description": "General host training program with property evaluation, contractor guidance, and listing setup assistance"
          },
          "price": "299",
          "priceCurrency": "USD"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Gold Package - Full-Service Solution",
            "description": "Complete setup package including permit assistance, contractor sourcing, space setup coordination, and multi-platform listing optimization"
          },
          "price": "999",
          "priceCurrency": "USD"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Platinum Package - Complete Turnkey Service",
            "description": "All-inclusive premium package with professional design, full project supervision, contractor hiring, and unlimited phone support for 3 months"
          },
          "price": "2999",
          "priceCurrency": "USD"
        }
      ]
    }
  };

  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [serviceSchema, faqSchema]
  };

  return (
    <>
      <SEOHead
        title="Airbnb Setup Services Newark DE | Silver Gold Platinum Packages | Aire University"
        description="Choose from three comprehensive Airbnb setup packages in Newark, Delaware: Silver ($299), Gold ($999), or Platinum ($2,999). Expert training, property design, permit assistance, contractor sourcing, and listing optimization. Free consultation available."
        keywords="Airbnb setup packages, Airbnb training Newark, property setup services, vacation rental packages, Airbnb management pricing, short-term rental setup Delaware"
        schema={combinedSchema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <ServiceHero />
        <PricingPlans />
        <ServiceDetails />
        <FAQ />
        <ContactCTA />
        <Footer />
      </div>
    </>
  );
}
